module.exports = __webpack_public_path__ + "68f2b7c9fa1dbe26416bfcdfa0aba038.png";